import Axios from "axios";
import React from "react";
import { Spin } from "../loading";
import { BarChart } from "../bar-chart";
import { LineChart } from "../line-chart";
import { PieChart } from "../pie-chart";

interface FaultOverviewProps {}

interface State {
  lineChart: unknown[];
  pieChart: unknown[];
  barChart: unknown[];
  loading: boolean;
}

export const FaultOverview: React.FC<FaultOverviewProps> = (props) => {
  const [state, setState] = React.useState<State>({
    lineChart: [],
    pieChart: [],
    barChart: [],
    loading: false,
  });

  React.useEffect(() => {
    setState({ ...state, loading: true });
    Axios.get(`/fault/overview`)
      .then((res) => {
        const { lineChart, pieChart, barChart } = res.data;

        setState({
          ...state,
          lineChart: [
            { label: "Lamppost", data: lineChart[0] },
            { label: "Bollard", data: lineChart[1] },
            { label: "Controller", data: lineChart[2] },
            { label: "Cable", data: lineChart[3] },
            { label: "GSDS", data: lineChart[4] },
          ],
          pieChart,
          barChart: [
            { label: "Lamppost", data: barChart[0] },
            { label: "Bollard", data: barChart[1] },
            { label: "Controller", data: barChart[2] },
            { label: "Cable", data: barChart[3] },
            { label: "GSDS", data: barChart[4] },
          ],
          loading: false,
        });
      })
      .finally(() => {
        setState((prev) => ({ ...prev, loading: false }));
      });
  // eslint-disable-next-line
  }, []);

  return (
    <div className="overview">
      <span className="title">fault overview</span>

      <div className="contract">
        {/* <span className="title">This Contract</span> */}

        <div style={{ width: "100%", height: "300px" }}>
          <Spin spin={state.loading}>
            <LineChart data={state.lineChart} />
          </Spin>
        </div>
      </div>

      <div>
        <span className="title">Latest Month</span>
        <div className="latest">
          <div className="left">
            <Spin spin={state.loading}>
              <PieChart
                data={state.pieChart}
                labels={["Lamppost", "Bollard", "Controller", "Cable", "GSDS"]}
              />
            </Spin>
          </div>

          <div className="right">
            <Spin spin={state.loading}>
              <BarChart data={state.barChart} />
            </Spin>
          </div>
        </div>
      </div>
    </div>
  );
};
